'use client';
import React from 'react';
import Link from 'next/link';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useLanguage } from '@/lib/LanguageContext';
import { getTranslations } from '@/lib/i18n';

// metadata removed - client component

const results = [
  { value: '60%', labelEs: 'Reducción de tiempo en procesos manuales', labelFr: 'Réduction du temps dans les processus manuels' },
  { value: '4 meses', labelEs: 'Tiempo de entrega del MVP', labelFr: 'Délai de livraison du MVP' },
  { value: '+500', labelEs: 'Usuarios activos en plataforma', labelFr: 'Utilisateurs actifs sur la plateforme' },
  { value: '99.5%', labelEs: 'Uptime de la aplicación', labelFr: 'Uptime de l\'application' },
];


const sectors = [
  { icon: 'fas fa-industry', labelEs: 'Industria', labelFr: 'Industrie' },
  { icon: 'fas fa-hospital', labelEs: 'Salud', labelFr: 'Santé' },
  { icon: 'fas fa-university', labelEs: 'Educación', labelFr: 'Éducation' },
  { icon: 'fas fa-store', labelEs: 'Retail', labelFr: 'Commerce' },
  { icon: 'fas fa-building', labelEs: 'Gobierno', labelFr: 'Gouvernement' },
  { icon: 'fas fa-truck', labelEs: 'Logística', labelFr: 'Logistique' },
];


const capabilities = [
  { icon: 'fas fa-code', titleEs: 'Desarrollo a Medida', titleFr: 'Développement Sur Mesure', descriptionEs: 'Construcción de aplicaciones web y móviles adaptadas exactamente a los procesos y requerimientos del negocio, sin compromisos con soluciones genéricas.', descriptionFr: 'Construction d\'applications web et mobiles adaptées exactement aux processus et exigences de l\'entreprise, sans compromis avec des solutions génériques.' },
  { icon: 'fas fa-mobile-alt', titleEs: 'Aplicaciones Móviles', titleFr: 'Applications Mobiles', descriptionEs: 'Desarrollo nativo e híbrido para iOS y Android con experiencias de usuario fluidas, integración con APIs y sincronización en tiempo real.', descriptionFr: 'Développement natif et hybride pour iOS et Android avec des expériences utilisateur fluides, intégration avec des API et synchronisation en temps réel.' },
  { icon: 'fas fa-plug', titleEs: 'Integraciones y APIs', titleFr: 'Intégrations et APIs', descriptionEs: 'Diseño e implementación de APIs RESTful y GraphQL para conectar sistemas existentes, plataformas de terceros y servicios en la nube.', descriptionFr: 'Conception et implémentation d\'API RESTful et GraphQL pour connecter les systèmes existants, les plateformes tierces et les services cloud.' },
  { icon: 'fas fa-database', titleEs: 'Arquitectura de Datos', titleFr: 'Architecture de Données', descriptionEs: 'Modelado de bases de datos relacionales y NoSQL, optimización de consultas y diseño de pipelines de datos para aplicaciones de alto rendimiento.', descriptionFr: 'Modélisation de bases de données relationnelles et NoSQL, optimisation des requêtes et conception de pipelines de données pour des applications haute performance.' },
  { icon: 'fas fa-cloud', titleEs: 'Despliegue en la Nube', titleFr: 'Déploiement dans le Cloud', descriptionEs: 'Implementación en AWS, Azure o GCP con infraestructura como código, CI/CD automatizado y escalado automático según demanda.', descriptionFr: 'Déploiement sur AWS, Azure ou GCP avec infrastructure en tant que code, CI/CD automatisé et mise à l\'échelle automatique selon la demande.' },
  { icon: 'fas fa-sync-alt', titleEs: 'Mantenimiento Evolutivo', titleFr: 'Maintenance Évolutive', descriptionEs: 'Soporte continuo, actualizaciones de seguridad y evolución funcional de las aplicaciones para adaptarse a los cambios del negocio.', descriptionFr: 'Support continu, mises à jour de sécurité et évolution fonctionnelle des applications pour s\'adapter aux changements de l\'entreprise.' },
];


export default function PortfolioDesarrolloSoftwarePage() {
  const { language } = useLanguage();
  const t = getTranslations(language);
  const p = t.portfolio;
  const isFr = language === 'fr';

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Nunito Sans', 'Raleway', arial, sans-serif" }}>
      <Navbar />
      {/* Hero */}
      <section
        className="relative overflow-hidden"
        style={{ paddingTop: '160px', paddingBottom: '80px', backgroundColor: '#0a0a0a' }}>
        
        <div className="absolute top-20 right-10 opacity-20 hidden lg:block">
          <img src="https://innobox.cl/wp-content/uploads/2021/07/Dots-4.svg" alt="" className="w-40 h-40" />
        </div>
        <div className="absolute bottom-0 left-0 opacity-10 hidden lg:block">
          <img src="https://innobox.cl/wp-content/uploads/2021/07/Abstract-Circle.svg" alt="" className="w-64 h-64" />
        </div>

        <div className="max-w-[1200px] mx-auto px-[35px] relative z-10">
          <nav className="mb-8 flex items-center gap-2 text-sm" style={{ color: '#888' }}>
            <Link href="/" className="hover:text-[#1AEF0F] transition-colors">{p.breadcrumbHome}</Link>
            <span>/</span>
            <Link href="/#portfolio" className="hover:text-[#1AEF0F] transition-colors">{p.breadcrumbPortfolio}</Link>
            <span>/</span>
            <span style={{ color: '#1AEF0F' }}>{isFr ? 'Développement Logiciel' : 'Desarrollo de Software'}</span>
          </nav>

          <div className="flex flex-col lg:flex-row items-start gap-12">
            <div className="flex-1">
              <div
                className="inline-flex items-center gap-2 mb-6 px-4 py-2"
                style={{ border: '1px solid #1AEF0F', color: '#1AEF0F', fontSize: '13px', letterSpacing: '2px' }}>
                
                <i className="fas fa-code" />
                <span>{isFr ? 'CAS D\'ÉTUDE' : 'CASO DE ESTUDIO'}</span>
              </div>
              <h1
                className="text-white font-bold mb-6"
                style={{
                  fontSize: 'clamp(32px, 4vw, 56px)',
                  fontFamily: "'Titillium Web', sans-serif",
                  lineHeight: '1.15'
                }}>
                
                {isFr ? 'Développement' : 'Desarrollo de'}<br />
                <span style={{ color: '#1AEF0F' }}>{isFr ? 'Logiciel' : 'Software'}</span>
              </h1>
              <p className="mb-8" style={{ fontSize: '18px', color: '#aaa', lineHeight: '1.7', maxWidth: '560px' }}>
                {isFr ? 'Application web d\'entreprise livrée en 4 mois, atteignant 60% de réduction des processus manuels et plus de 500 utilisateurs actifs.' : 'Aplicación web empresarial entregada en 4 meses, logrando 60% de reducción en procesos manuales y más de 500 usuarios activos.'}
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="https://calendar.app.google/qrMMuz1WHJJ4eoab8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative inline-flex items-center overflow-hidden"
                  style={{
                    border: '1px solid #1AEF0F',
                    padding: '14px 32px',
                    fontSize: '15px',
                    fontWeight: 'bold',
                    color: '#1AEF0F',
                    backgroundColor: 'transparent',
                    transition: 'all 300ms ease-out'
                  }}>
                  
                  <span className="relative z-10 transition-colors duration-300 group-hover:text-black">
                    {isFr ? 'Projet Similaire' : 'Proyecto Similar'}
                  </span>
                  <span
                    className="absolute inset-0 transform translate-x-full group-hover:translate-x-0 transition-transform duration-300"
                    style={{ backgroundColor: '#1AEF0F', zIndex: 0 }} />
                  
                </a>
                <Link
                  href="/#portfolio"
                  className="inline-flex items-center gap-2 text-white hover:text-[#1AEF0F] transition-colors"
                  style={{ fontSize: '15px', padding: '14px 0' }}>
                  
                  <i className="fas fa-arrow-left text-sm" />
                  {isFr ? 'Voir tout le portfolio' : 'Ver todo el portfolio'}
                </Link>
              </div>
            </div>

            {/* Stats */}
            <div className="lg:w-72 grid grid-cols-2 gap-4">
              {results?.map((stat, i) =>
              <div key={i} className="p-5" style={{ border: '1px solid #222', backgroundColor: '#111' }}>
                  <div className="font-bold mb-1" style={{ fontSize: '28px', color: '#1AEF0F', fontFamily: "'Titillium Web', sans-serif" }}>
                    {stat?.value}
                  </div>
                  <div style={{ fontSize: '12px', color: '#888', lineHeight: '1.4' }}>{isFr ? stat.labelFr : stat.labelEs}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      {/* Project Image */}
      <section style={{ backgroundColor: '#111' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_133396a73-1768649601954.png"
            alt="Desarrollo de Software - aplicaciones a medida desarrolladas por Innobox"
            className="w-full"
            style={{ display: 'block', maxHeight: '480px', objectFit: 'cover' }} />
          
        </div>
      </section>
      {/* Project Overview */}
      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#fff' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <h2 className="font-bold text-black mb-6" style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', fontFamily: "'Titillium Web', sans-serif" }}>
                Descripción del Proyecto
              </h2>
              <p style={{ fontSize: '16px', color: '#505050', lineHeight: '1.8', marginBottom: '20px' }}>
                Desarrollo de una plataforma de gestión operacional para una empresa industrial con múltiples plantas 
                productivas. La solución reemplazó procesos manuales en papel y hojas de cálculo por un sistema 
                centralizado con trazabilidad completa y reportes en tiempo real.
              </p>
              <p style={{ fontSize: '16px', color: '#505050', lineHeight: '1.8' }}>
                El proyecto se ejecutó con metodología ágil en sprints de dos semanas, con entregas incrementales 
                que permitieron validar funcionalidades con usuarios reales desde las primeras semanas del desarrollo.
              </p>
            </div>
            <div>
              <h2 className="font-bold text-black mb-6" style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', fontFamily: "'Titillium Web', sans-serif" }}>
                Stack Tecnológico
              </h2>
              <div className="space-y-3">
                {['React / Next.js (Frontend)', 'Node.js / Express (Backend)', 'PostgreSQL + Redis', 'Docker / Kubernetes', 'AWS (ECS, RDS, S3)', 'GitHub Actions (CI/CD)']?.map((tech, i) =>
                <div key={i} className="flex items-center gap-3">
                    <span style={{ width: '8px', height: '8px', backgroundColor: '#1AEF0F', borderRadius: '50%', flexShrink: 0 }} />
                    <span style={{ fontSize: '15px', color: '#333' }}>{tech}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Challenge / Solution */}
      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#f5f5f5' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-10" style={{ backgroundColor: '#0a0a0a' }}>
              <div className="flex items-center gap-3 mb-6">
                <i className="fas fa-exclamation-triangle text-yellow-400 text-xl" />
                <h3 className="font-bold text-white" style={{ fontSize: '22px', fontFamily: "'Titillium Web', sans-serif" }}>
                  El Desafío
                </h3>
              </div>
              <p style={{ fontSize: '15px', color: '#aaa', lineHeight: '1.8', marginBottom: '16px' }}>
                La empresa gestionaba sus operaciones con planillas Excel compartidas por correo electrónico, 
                generando versiones desactualizadas, errores de digitación y pérdida de información crítica. 
                Los reportes gerenciales tardaban días en consolidarse.
              </p>
              <p style={{ fontSize: '15px', color: '#aaa', lineHeight: '1.8' }}>
                La solución debía integrarse con el ERP existente, soportar usuarios concurrentes desde múltiples 
                plantas y funcionar en dispositivos móviles para operadores en terreno.
              </p>
            </div>
            <div className="p-10" style={{ backgroundColor: '#1AEF0F' }}>
              <div className="flex items-center gap-3 mb-6">
                <i className="fas fa-check-circle text-black text-xl" />
                <h3 className="font-bold text-black" style={{ fontSize: '22px', fontFamily: "'Titillium Web', sans-serif" }}>
                  La Solución
                </h3>
              </div>
              <p style={{ fontSize: '15px', color: '#0a0a0a', lineHeight: '1.8', marginBottom: '16px' }}>
                Desarrollamos una plataforma web progresiva (PWA) con sincronización offline, dashboards en tiempo 
                real y un módulo de reportes configurable. La integración con el ERP se realizó mediante una API 
                bidireccional con sincronización automática cada 15 minutos.
              </p>
              <p style={{ fontSize: '15px', color: '#0a0a0a', lineHeight: '1.8' }}>
                El sistema fue desplegado en AWS con alta disponibilidad, backups automáticos y un pipeline de 
                CI/CD que permite desplegar nuevas funcionalidades en minutos sin interrupciones de servicio.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Capabilities */}
      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#fff' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="mb-12">
            <h2 className="font-bold text-black mb-3" style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', fontFamily: "'Titillium Web', sans-serif" }}>
              Capacidades Aplicadas
            </h2>
            <p style={{ fontSize: '16px', color: '#505050', maxWidth: '600px', lineHeight: '1.6' }}>
              Competencias técnicas y metodológicas que hicieron posible este proyecto de desarrollo de software.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0">
            {capabilities?.map((cap, i) =>
            <div
              key={i}
              className="group p-8 transition-all duration-300 hover:bg-[#f9f9f9]"
              style={{ borderBottom: '1px solid #E2E2E2', borderRight: i % 3 !== 2 ? '1px solid #E2E2E2' : 'none' }}>
              
                <div className="mb-5 flex items-center justify-center" style={{ width: '52px', height: '52px', border: '1px solid #E2E2E2', borderRadius: '50%' }}>
                  <i className={`${cap?.icon} text-xl text-black group-hover:text-[#1AEF0F] transition-colors duration-300`} />
                </div>
                <h3 className="font-semibold text-black mb-3" style={{ fontSize: '17px', fontFamily: "'Titillium Web', sans-serif" }}>{cap?.title}</h3>
                <p style={{ fontSize: '14px', color: '#505050', lineHeight: '1.6' }}>{cap?.description}</p>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* Sectors */}
      <section style={{ paddingTop: '60px', paddingBottom: '80px', backgroundColor: '#f5f5f5' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <h2 className="font-bold text-black mb-10" style={{ fontSize: 'clamp(22px, 2vw, 30px)', fontFamily: "'Titillium Web', sans-serif" }}>
            Sectores que Atendemos
          </h2>
          <div className="flex flex-wrap gap-4">
            {sectors?.map((s, i) =>
            <div key={i} className="flex items-center gap-3 px-6 py-4 bg-white" style={{ border: '1px solid #E2E2E2' }}>
                <i className={`${s?.icon} text-[#1AEF0F]`} />
                <span style={{ fontSize: '15px', fontWeight: '600', color: '#111' }}>{s?.label}</span>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* CTA */}
      <section style={{ paddingTop: '70px', paddingBottom: '70px', backgroundColor: '#1AEF0F' }}>
        <div className="max-w-[1200px] mx-auto px-[35px] flex flex-col sm:flex-row items-center justify-between gap-6">
          <p className="text-black font-bold m-0" style={{ fontSize: 'clamp(18px, 2vw, 26px)', fontFamily: "'Titillium Web', sans-serif", lineHeight: '1.3' }}>
            ¿Tienes un proyecto de software en mente?
          </p>
          <Link href="/contact" className="group relative inline-flex items-center overflow-hidden border border-black text-black bg-transparent flex-shrink-0"
            style={{ padding: '14px 32px', fontSize: '15px', fontWeight: 'bold', transition: 'all 300ms ease-out' }}>
            
            <span className="relative z-10 transition-colors duration-300 group-hover:text-white">Contáctenos</span>
            <span className="absolute inset-0 bg-black transform translate-x-full group-hover:translate-x-0 transition-transform duration-300" style={{ zIndex: 0 }} />
          </Link>
        </div>
      </section>
      <Footer />
    </div>);

}